<template>
  <div class="manage-content">
    <div class="page-title mt-10">
      {{ $t('text.roles') }}
    </div>
    <div class="mt-20 page-content">
      <div>
        <div class="section-title mb-20">
          <el-button
            class="save-btn mini-btn"
            type="success"
            plain
            @click="addRole()"
            v-if="p('Manage.Roles.Add')"
            >{{ $t('text.add').toUpperCase() }}</el-button
          >
          <span class="right-float">
            <img src="../../assets/filter.svg" />
            <el-input
              v-model="filter"
              size="mini"
              class="search-input filter-input"
              :placeholder="$t('text.filter_by_role_name')"
            ></el-input>
          </span>
        </div>
        <el-table
          border
          ref="table"
          size="small"
          :data="roleList"
          v-loading="loading"
          :max-height="tableHeight"
        >
          <el-table-column
            :label="$t('text.role') | firstLetterCapitalize"
            prop="roleName"
          ></el-table-column>
          <el-table-column
            :label="$t('text.action') | firstLetterCapitalize"
            width="250px"
            fixed="right"
            v-if="p('Manage.Roles.Delete') || p('Manage.Roles.Edit')"
          >
            <template slot-scope="scope">
              <el-button
                type="success"
                plain
                class="save-btn mini-btn min-w-80"
                @click="editRole(scope.row)"
                v-if="p('Manage.Roles.Edit')"
                >{{ $t('text.edit').toUpperCase() }}</el-button
              >
              <el-button
                type="success"
                plain
                class="delete-btn mini-btn min-w-80 ml-10"
                @click="deleteRow(scope.row)"
                v-if="p('Manage.Roles.Delete')"
                >{{ $t('text.delete').toUpperCase() }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <EditRole ref="editRole" />
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
import EditRole from '@/components/manage/EditRole'
export default {
  data() {
    return {
      filter: '',
      roleList: [],
      loading: false,
      timer: '',
      user: JSON.parse(localStorage.getItem('user')),
      tableHeight: 0
    }
  },
  components: {
    EditRole
  },
  mounted() {
    this.getRoleList()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 50
      let self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 50
      }
    })
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getRoleList, 500)
    }
  },
  methods: {
    getRoleList() {
      this.loading = true
      ApiService.GetRoles()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.roleList = response.data.data
            if (this.filter) {
              let vm = this
              this.roleList = this.roleList.filter(
                item =>
                  item.roleName.toLowerCase().indexOf(vm.filter.toLowerCase()) >
                  -1
              )
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    addRole() {
      this.$refs.editRole.openDialog()
    },
    editRole(row) {
      this.$refs.editRole.form = JSON.parse(JSON.stringify(row))
      this.$refs.editRole.openDialog()
    },
    deleteRow(row) {
      this.$confirm(
        this.$t('text.delete_role_confirm'),
        this.$t('text.you_able_to_delete_data') + ' ' + row.roleName,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => {
          this.handleDeleteRole(row.id)
        })
        .catch(() => {})
    },
    handleDeleteRole(id) {
      ApiService.DeleteRole(id)
        .then(response => {
          if (response.data.success) {
            this.getRoleList()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Deleted Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Deleted Failed'
          })
        })
    }
  }
}
</script>
